import { Component } from '@angular/core';
import { Subscription } from "rxjs";
import { StompSocketAPI } from "../api/stompApi";

@Component({
    selector: 'app-root',
    templateUrl: './messenger.component.html',
    styleUrls: ['./messenger.component.scss'],
    standalone: false
})

export class MessengerComponent  {
  messageText = 'Message';
  url: string;
  messageFromServer = '';
  wsSubscription: Subscription;
  socketAPI;

  ngOnInit() {
    this.socketAPI = new StompSocketAPI(this);
  }

  handleMessage(message: String) {
    this.messageFromServer += "\r\n" + message;
  }

  clearMessage() {
    this.messageText = '';
  }

  sendMessageToServer() {
//     this.socketAPI._send(this.messageText);
  }

  closeSocket() {
    this.wsSubscription.unsubscribe();
  }

  ngOnDestroy() {
    this.closeSocket();
  }
}
